import { DEFAULT_NETWORK, isChainIdL1 } from '@cronos-app/sdk';
import { useRef } from 'react';
import { useGlobalContextStore, useOverrideGlobalContextStore, } from './globalContext';
import { currentWallet } from './wallets';
const useAccount = process.env.IS_PROD
    ? currentWallet.useAccount
    : () => {
        const accountFromStore = useGlobalContextStore((s) => s.account);
        const accountFromWallet = currentWallet.useAccount();
        return accountFromStore ? accountFromStore : accountFromWallet;
    };
const ensureValidNetwork = (network) => {
    return network && isChainIdL1(network) ? network : DEFAULT_NETWORK;
};
const useDesiredNetwork = process.env.IS_PROD
    ? () => {
        const overrideNetwork = useOverrideGlobalContextStore.getState().network;
        return ensureValidNetwork(overrideNetwork);
    }
    : () => {
        const network = useGlobalContextStore((s) => s.network);
        return ensureValidNetwork(network);
    };
const useProvider = (...args) => {
    const provider = currentWallet.useProvider(...args);
    const previousProviderRef = useRef(provider);
    /**
     * need to destroy the previous provider and stop all subscriber listeners
     * VNO-527 page crashes if the user is switching network when depositing
     * @see https://cronoslabs.atlassian.net/browse/VNO-527
     * @see https://github.com/ethers-io/ethers.js/issues/4015
     * @see https://github.com/ethers-io/ethers.js/issues/4806
     */
    const previousProvider = previousProviderRef.current;
    if (provider && provider !== previousProvider) {
        previousProvider
            ?.emit('debug', {
            action: 'destroy',
        })
            .finally(() => {
            previousProvider.destroy();
        });
        previousProviderRef.current = provider;
    }
    return provider;
};
export const currentWalletWithGlobalContext = {
    ...currentWallet,
    useAccount,
    useDesiredNetwork,
    useProvider,
};
